<template>
  <div class="text-center mx-auto">
    <h1>Novo curso</h1>
    <v-divider></v-divider>
    <FormCourse
      :course="course"
      :is-new="true"
      @submitCourse="createCourse($event)"
    ></FormCourse>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FormCourse from '@/pages/admin/components/course/FormCourse';
import Course from '@/models/course';
import AdminCourseService from "@/services/admin-course/admin-course.service";
import AdminMachineService from "@/services/admin-machine/admin-machine.service";

const adminCourseService = new AdminCourseService();
const adminMachineService = new AdminMachineService();

export default {
  name: 'CreateCourse',
  components: { FormCourse },
  data: () => ({
    course: new Course(),
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    createCourse(course) {
      course.description = !course.description ? course.name : course.description;
      this.loading = true;

      adminCourseService.createCourse(course)
        .then((response) => {
          this.showSnack(response.data.message);
          const courseId = response.data.course.id;

          const machines = course.machines.map((machine) => adminMachineService.createMachine(courseId, machine));

          Promise.all(machines)
            .then((responses) => {
              this.loading = false;
              this.$router.push(`/admin/course/${courseId}/edit`);
            })
            .catch((err) => {
              let message;

              if (Array.isArray(err)) {
                message = err[0]?.response?.data?.message
              } else {
                message = err?.response?.data?.message ?? 'Falha ao criar máquinas';
              }

              this.loading = false;
              this.showSnack(message);
              this.$router.push(`/admin/course/${courseId}/edit`);
            });
        })
        .catch((err) => {
          this.loading = false;
          this.showSnack(err?.response?.data?.message ?? 'Falha ao criar o curso');
        });
    },
  },
};
</script>

<style scoped>

</style>
